import React from "react";
import { Col, Container, Row, Modal, Form } from "react-bootstrap";
import Input, { PasswordInput } from "../components/Input";
import "../stylesheets/login.scss";
import Close from "../Assets/close.svg";
import Navbar from "../components/Navbar";
import Checkbox from "../util/Btns/CheckboxBtnv1";
import { Link } from "react-router-dom";
import ConsoleLocalStorage from "../storage/storage";
import PrimaryButton from "../util/Btns/PrimaryButton";
import { CustomToast } from "../util/custom-toast/CustomToast";
import DevAuthAPI from "../api/DevAuth";
import DevConsoleAPI from "../api/DevConsole";
import { showLoader, hideLoader } from "../util/loader/CustomLoader";
import { orgStatus } from "../util/helpers/statusHelper";
import { GetQueryParam } from "../util/helpers/funcHelper";
import { DEV_CONSOLE_URL } from "../config";
import {
  DISCORD_INVITE,
  GET_DISCORD_ACCESS,
} from "../util/helpers/connectionString";
import axios from "axios";
import { API } from "../api/api";
import InvalidLicenseModal from "./InvalidLicenseModal";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: { value: "", warning: { msg: "", class: "" } },
      password: { value: "", warning: { msg: "", class: "" } },
      remember: false,
      modal: false,
    };
  }
  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  componentDidMount() {
    let orgData = ConsoleLocalStorage.getOrganization();
    if (!orgData) {
      this.props.history.replace(`/login${this.props.location.search}`);
    } else if (orgData && Object.keys(orgData).length === 0) {
      setTimeout(() => this.props.history.replace("/organization"), 10);
    } else if (orgData.status === orgStatus.approved.status) {
      if (GetQueryParam("redirectTo")) {
        setTimeout(
          () => this.props.history.replace(`${GetQueryParam("redirectTo")}`),
          10
        );
      } else {
        setTimeout(() => this.props.history.replace("/console"), 10);
      }
    } else if (orgData.status === orgStatus.revoked.status) {
      this.setState({ modal: true });
      this.clearLocalStorage();
    } else {
      setTimeout(() => this.props.history.replace("/create"), 10);
    }
  }

  submitLogin(e) {
    console.log("APi called");

    let validate = true;
    if (!this.validateEmail(this.state.email.value)) {
      let tempState = { ...this.state.email };
      tempState.warning.msg = "Invalid Email";
      tempState.warning.class = "border-red red";
      this.setState({ email: tempState });
      validate = false;
    }
    if (this.state.password.value.length < 8) {
      let tempState = { ...this.state.password };
      tempState.warning.msg = "Invalid Password";
      tempState.warning.class = "border-red red";
      this.setState({ password: tempState });
      validate = false;
    }

    if (!validate) return;

    showLoader();
    let api = new DevAuthAPI();
    api
      .developerLogin({
        email: this.state.email.value,
        password: this.state.password.value,
        source: "https://developer.tesseract.in",
      })
      .then((response) => this.onSuccess(response))
      .catch((error) => this.onError(error));
  }

  onSuccess(response) {
    // handle success

    hideLoader();

    ConsoleLocalStorage.setAccessToken(response.data.data.access_token);
    ConsoleLocalStorage.setRefreshToken(response.data.data.refresh_token);
    ConsoleLocalStorage.setRememberMe(this.state.remember);
    ConsoleLocalStorage.setUser(response.data.data.user);

    let user = response.data.data.user;
    if (user?.id) {
      this.getDiscordAccess(user);
    }
    if (!user.email_verified) {
      this.props.history.replace("/verify-mail");
    } else if (!user.organization) {
      let api2 = new DevConsoleAPI();
      api2
        .getOrganizationWithToken()
        .then((res) => {
          // console.log("working",res.data.data);
          let data = res.data.data;
          ConsoleLocalStorage.setOrganization(res.data.data);
          if (data && Object.keys(data).length === 0) {
            setTimeout(() => this.props.history.replace("/organization"), 10);
          } else if (data.status === orgStatus.approved.status) {
            if (!ConsoleLocalStorage.getFTU()) {
              ConsoleLocalStorage.setFTU("true");
            }
            if (GetQueryParam("redirectTo")) {
              setTimeout(
                () =>
                  this.props.history.replace(`${GetQueryParam("redirectTo")}`),
                10
              );
            } else {
              setTimeout(() => this.props.history.replace("/console"), 10);
            }
          } else if (data.status === orgStatus.revoked.status) {
            this.setState({ modal: true });
            this.clearLocalStorage();
          } else if (data.status === orgStatus.approved.rejected) {
            setTimeout(() => this.props.history.replace("/create"), 10);
          } else this.props.history.replace("/create");
          // ConsoleLocalStorage.setOrganization(res.data.data);
          // if (res.data.data.status === orgStatus.approved.status) {
          //   setTimeout(() => this.props.history.replace("/console"), 10);
          // } else this.props.history.replace("/create");
        })
        .catch((error) => {
          console.log("not working");
          CustomToast(error.message);
        });
      // console.log(ConsoleLocalStorage.getOrganization());
    } else if (user.organization !== undefined) {
      let api2 = new DevConsoleAPI();
      api2
        .getOrganization(user.organization)
        .then((res) => {
          console.log("working");
          let data = res.data.data;
          ConsoleLocalStorage.setOrganization(data);
          let userData = ConsoleLocalStorage.getUser();

          if (userData && (!userData.firstName || !userData.lastName)) {
            this.props.history.replace("/console/profile");
          } else if (data.status === orgStatus.revoked.status) {
            this.setState({ modal: true });
            this.clearLocalStorage();
          } else if (data.status === orgStatus.approved.status) {
            if (!ConsoleLocalStorage.getFTU()) {
              ConsoleLocalStorage.setFTU("true");
            }
            if (GetQueryParam("redirectTo")) {
              setTimeout(
                () =>
                  this.props.history.replace(`${GetQueryParam("redirectTo")}`),
                10
              );
            } else {
              setTimeout(() => this.props.history.replace("/console"), 10);
            }
          } else {
            this.props.history.replace("/create");
          }
        })
        .catch((error) => {
          console.log("not working");
          CustomToast(error.message);
        });
      console.log(ConsoleLocalStorage.getOrganization());
    } else {
      this.props.history.replace("/");
    }

    // console.log(response);
  }
  onError(error) {
    hideLoader();

    // handle error
    // console.log(error.response.data);

    CustomToast(error?.response?.data?.message);

    let tempState = { ...this.state.password };

    tempState.warning = { msg: "Incorrect", class: "border-red red" };

    this.setState({ password: tempState });
  }

  discordVerifyBackend = (data, user) => {
    showLoader();
    axios
      .get(`${DISCORD_INVITE}${data?.code}`)
      .then((response) => {
        hideLoader();
        ConsoleLocalStorage.setDiscordJoined(false);
        ConsoleLocalStorage.setDiscordVerified(true);
      })
      .catch((error) => {
        hideLoader();
        if (error?.response?.data?.code === 10006) {
          API(
            `${DEV_CONSOLE_URL}${GET_DISCORD_ACCESS}${user?.id}/joined`,
            "POST"
          );
          ConsoleLocalStorage.setDiscordJoined(true);
          ConsoleLocalStorage.setDiscordVerified(true);
        }
      });
  };

  getDiscordAccess = (user) => {
    showLoader();
    API(`${DEV_CONSOLE_URL}${GET_DISCORD_ACCESS}${user?.id}`, "GET")
      .then((response) => {
        hideLoader();
        ConsoleLocalStorage.setDiscordInviteUrl(response.data.data?.invite);
        ConsoleLocalStorage.setDiscordAccessUrl(response.data.data?.access);
        if (!response.data.data?.verified) {
          try {
            this.discordVerifyBackend(response.data.data, user);
          } catch (error) {
            console.log(error);
          }
        } else {
          ConsoleLocalStorage.setDiscordJoined(response.data.data?.joined);
          ConsoleLocalStorage.setDiscordVerified(response.data.data?.verified);
        }
      })
      .catch((error) => {
        hideLoader();
        console.log(error);
      });
  };

  handleClose = () => {
    localStorage.clear();
    this.props.history.replace("/");
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.email !== null && this.state.password !== null) {
      this.submitLogin();
    }
  };

  handleCloseLicense = () => {
    ConsoleLocalStorage.clearStorageExceptFTU();
    this.setState({ modal: false });
    this.props.history.replace("/login");
  };

  clearLocalStorage = () => {
    window.onbeforeunload = function (e) {
      localStorage.clear();
    };
  };

  render() {
    return (
      <div className="login_page">
        <Navbar showSignup={true} />
        <Container fluid className="main-container">
          <Modal
            onHide={this.handleClose}
            show={true}
            centered
            contentClassName="login-modal p-2"
          >
            <Modal.Body className="pb-0">
              <Container>
                <Row>
                  <Col xs={10} md={11} className="px-0">
                    <h4
                      style={{
                        color: "#FFFFFF",
                        fontSize: "1rem",
                        marginBottom: "0",
                      }}
                    >
                      Sign In now
                    </h4>
                    <p className="sub-title">
                      or{" "}
                      <Link to="/signup">
                        <span>
                          {"Sign Up "}
                          <img
                            className="arrow"
                            src="https://img.icons8.com/fluent-systems-filled/512/77BAFF/more-than.png"
                            height="15"
                            width="15"
                            alt="Logo"
                          />
                        </span>
                      </Link>
                    </p>
                  </Col>
                  <Col xs={2} md={1} className="px-0 ">
                    <span className="float-right">
                      <Link>
                        <img
                          src={Close}
                          height="14"
                          width="14"
                          alt="cross"
                          onClick={() => this.handleClose()}
                        />
                      </Link>
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Form onSubmit={this.handleSubmit} noValidate>
                    <Col xs={12} md={12} className="px-0">
                      <Input
                        required="true"
                        label="Email ID"
                        type="email"
                        name="email"
                        maxLen="256"
                        warning={this.state.email.warning}
                        value={this.state.email.value}
                        autoComplete="nope"
                        onChange={(e) => {
                          let tempState = { ...this.state.email };
                          tempState.value = e.target.value;

                          if (e.target.value.length === 0) {
                            tempState.warning.msg = "";
                            tempState.warning.class = "";
                          }
                          if (
                            e.target.value.length < 6 &&
                            e.target.value.length > 0
                          ) {
                            tempState.warning.msg =
                              "Minimum 6 characters required";
                            tempState.warning.class = "border-red red";
                          } else if (
                            !this.validateEmail(e.target.value) &&
                            e.target.value
                          ) {
                            tempState.warning.msg = "Invalid Email";
                            tempState.warning.class = "border-red red";
                          } else
                            tempState.warning = {
                              msg: "",
                              class: "",
                            };
                          this.setState({ email: tempState });
                        }}
                        style={{ marginBottom: "-5px" }}
                      />

                      <PasswordInput
                        label="Password"
                        type="password"
                        name="password"
                        maxLen="128"
                        warning={this.state.password.warning}
                        value={this.state.password.value}
                        autoComplete="nope"
                        onChange={(e) => {
                          let tempState = { ...this.state.password };
                          tempState.value = e.target.value;
                          tempState.warning = { msg: "", class: "" };
                          if (
                            e.target.value.length < 8 &&
                            e.target.value.length > 0
                          ) {
                            tempState.warning = {
                              msg: "Minimum 8 Characters Required",
                              class: "border-red red",
                            };
                          }
                          this.setState({ password: tempState });
                        }}
                      />

                      <p className="sub-title">
                        <Link
                          to="/forgot-password"
                          style={{
                            margin: "0 0 0 0",
                            fontFamily: "JioType-Medium",
                            fontSize: "0.8rem",
                          }}
                        >
                          {"Forgot Password?"}
                        </Link>
                      </p>

                      <Row
                        className="mb-3 btm-view-login"
                        style={{ marginTop: "25px" }}
                      >
                        <Col xs={9}>
                          <Checkbox
                            label="Remember Me"
                            id="remember-me"
                            onChange={(e) =>
                              this.setState({ remember: e.target.checked })
                            }
                          />
                        </Col>
                        <Col xs={3} className="px-0">
                          <PrimaryButton type="submit">Sign In</PrimaryButton>
                        </Col>
                      </Row>
                    </Col>
                  </Form>
                </Row>
              </Container>
            </Modal.Body>
          </Modal>
          <InvalidLicenseModal
            open={this.state.modal}
            handleCloseLicense={this.handleCloseLicense}
          />
        </Container>
      </div>
    );
  }
}

export default Login;
